import { KYMW9006Component } from "./kymw9006.component";
/**
 * パスワード変更画面の値を管理するクラス
 */
export class KYMW9006Model {
  kymw9006Component: KYMW9006Component;

  /** 現在のパスワード */
  public password: string = <string>'';

  /** 新しいパスワード */
  public newPassword: string = <string>'';

  /** 新しいパスワード(確認) */
  public reNewPassword: string = <string>'';

  /** ユーザId */
  public userId: string = <string>'';
}